import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell, Label,
    LabelList,
    ResponsiveContainer,
    Tooltip,
    TooltipProps,
    XAxis,
    YAxis
} from "recharts";
import React from "react";
import classNames from "classnames";
import {ChartModel} from "../models/ChartDataModel";
import {CustomLegend} from "./customDashboardComponents/customLegend";
import CustomTooltipContent from "../../../core/components/tooltips/CustomTooltipContent";
import {Localizer} from "../../../infrastructure/localization/localizer";
import useScreenResolution from "../../../core/hooks/useScreenResolution";

type SimpleBarChartProps = {
    dataset: ChartModel;
    totalAmount: number;
    hideLegends?: boolean;
    xLabel?: string;
    yLabel?: string;
    heightOverride?: number;
}


export const SimpleBarChart = ({dataset, totalAmount, hideLegends = false, xLabel, yLabel, heightOverride}: SimpleBarChartProps) => {
    const {isMobile} = useScreenResolution();
    const CustomTooltip = ({active, payload, label}: TooltipProps<any, any>) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const index = dataset.elements.indexOf(data);
            return (
                <CustomTooltipContent>
                    <CustomTooltipContent.Item
                        key={index}
                        index={index}
                        color={data.fill}
                        text={`${label} (${data.amount})`}
                        subtleText={`${Localizer.dashboard_part()}: ${(data.amount / totalAmount * 100).toFixed(0)}%`}
                    />
                </CustomTooltipContent>
            );
        }
        return null;
    };

    return (
        <>
            <div className={classNames("wrap flex-container-row")} >
                <ResponsiveContainer width={"100%"} height={heightOverride ?? 350}>
                    <BarChart
                        data={dataset.elements}
                        margin={{
                            top: 30,
                            right: 20,
                            left: isMobile ? -20 : 0,
                            bottom: xLabel ? 20 : 5,
                        }}
                        barCategoryGap={"30%"}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false}/>
                        <XAxis dataKey={"name"} tickLine={false}>
                            {xLabel &&
                                <Label fontSize={12} value={xLabel} position="insideBottom" offset={-10} />
                            }
                        </XAxis>
                        <YAxis tickLine={false} tickCount={7}>
                            {yLabel &&
                                <Label fontSize={12} value={yLabel} position="insideTopLeft" dx={10} dy={-35}/>
                            }
                        </YAxis>
                        <Tooltip content={<CustomTooltip/>}/>
                        <Bar dataKey={"amount"} maxBarSize={16}
                             radius={[20, 20, 0, 0]}>
                            {dataset.elements.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.fill} onClick={entry.handleOnClick} cursor={!!entry.handleOnClick ? 'pointer' : 'default'}/>
                            ))}
                            <LabelList dataKey="amount" position="top"/>
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
            {!hideLegends &&
                <div className={classNames("align-self-center wrap flex-center")}>
                    <div className={classNames("flex-wrap flex-container-row")}>
                        <CustomLegend key={`${dataset.name}`}
                                      text={`${dataset?.name}`}
                                      color={dataset?.elements[0].fill}
                        />

                    </div>
                </div>
            }
        </>

    );
}
